import { css } from '@emotion/react'

type PropsType = {
	lineWidth?: number
	width?: number
	height?: number
}
const LoadingIcon = ({ lineWidth = 4, width = 50, height = 50 }: PropsType) => {
	const iconStyle = css`
		display: inline-block;
		position: relative;
		width: ${width}px;
		height: ${height}px;
		& div {
			box-sizing: border-box;
			display: block;
			position: absolute;
			width: 100%;
			height: 100%;
			border: ${lineWidth}px solid #fece37;
			border-radius: 50%;
			animation: circle-animation 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
			border-color: #fece37 transparent transparent transparent;
		}

		& div:nth-of-type(1) {
			animation-delay: -0.45s;
		}
		& div:nth-of-type(2) {
			animation-delay: -0.3s;
		}
		& div:nth-of-type(3) {
			animation-delay: -0.15s;
		}
		@keyframes circle-animation {
			0% {
				transform: rotate(0deg);
			}
			100% {
				transform: rotate(360deg);
			}
		}
	`
	return (
		<div css={iconStyle}>
			<div />
			<div />
			<div />
			<div />
		</div>
	)
}

export default LoadingIcon
